"use client";

import { Heart, House as Home } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Japanesecommunityreferral() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const infoTiles = [{
    icon: Home,
    label: "Years of Practice",
    value: "40+",
    sublabel: "serving South Florida clients"
  }, {
    icon: Heart,
    label: "Referral Network",
    value: "150+",
    sublabel: "trusted professional partners"
  }];
  return;
}